import React from 'react';

import Social from '../Social';
import H1 from '../H1';
import P from './P';
import Link from './Link';
import Wrapper from './Wrapper';
import Button from '../Button';

function Header({ config }) {
  const { title, description, social } = config;

  const divStyles = {
    'paddingTop': '75px',
  };

  return (
    <Wrapper>
      <H1><Link to="/">{title}</Link></H1>
      <P>{description}</P>
      {social &&
        <Social
          website={social.website}
          github={social.github}
          twitter={social.twitter}
          linkedin={social.linkedin}
        />
      }
      <div style={divStyles}>
        <Button to="/">Home</Button>
      </div>
    </Wrapper>
  );
}

export default Header;